export default (date) => {
  // Create a Date object from the GMT date string
  var myDate = new Date(date);
  return myDate.toLocaleString();
};
